export default "__VITE_ASSET__koA_nZbb__";